import { render } from "./ActiveQuestion.vue?vue&type=template&id=9b09e35a&scoped=true"
import script from "./ActiveQuestion.vue?vue&type=script&lang=js"
export * from "./ActiveQuestion.vue?vue&type=script&lang=js"

import "./ActiveQuestion.vue?vue&type=style&index=0&id=9b09e35a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b09e35a"]])

export default __exports__